var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpand = function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.218 4.74a.6.6 0 0 1-.6.6h-4.43l2.926 2.928 1.552 1.551a.6.6 0 1 1-.849.849L8.266 9.116 5.339 6.19v4.431a.6.6 0 1 1-1.2 0V4.74a.6.6 0 0 1 .6-.6h5.88a.6.6 0 0 1 .6.6Zm1.702 8.182a.6.6 0 0 1 .849 0l1.551 1.552 3.22 3.219v-4.31a.6.6 0 0 1 1.2 0v5.879a.6.6 0 0 1-.6.6h-5.88a.6.6 0 1 1 0-1.2h4.551l-3.34-3.34-1.55-1.551a.6.6 0 0 1 0-.849Z",
    clipRule: "evenodd"
  })));
};
export default SvgExpand;